export default IconCurrencyNano => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-nano" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 20l10 -16" />
  <path d="M7 12h10" />
  <path d="M7 16h10" />
  <path d="M17 20l-10 -16" />
</svg>`;